import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../context/AuthContext';
import {
  Title,
  Card,
  Table,
  Button,
  Group,
  Text,
  PasswordInput,
  Stack,
  Badge,
  Alert,
  Grid,
  ThemeIcon
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import {
  IconSettings,
  IconUser,
  IconLock,
  IconCheck,
  IconAlertCircle
} from '@tabler/icons-react';

function Profilo() {
  const { user } = useAuth();
  const [form, setForm] = useState({
    password_attuale: '',
    password_nuova: '',
    password_conferma: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (form.password_nuova !== form.password_conferma) {
      setError('Le password non coincidono');
      return;
    }

    if (form.password_nuova.length < 6) {
      setError('La password deve essere di almeno 6 caratteri');
      return;
    }

    setLoading(true);
    try {
      await api.put('/auth/cambio-password', {
        password_attuale: form.password_attuale,
        password_nuova: form.password_nuova
      });
      setSuccess('Password modificata con successo!');
      setForm({ password_attuale: '', password_nuova: '', password_conferma: '' });
      notifications.show({ title: 'Successo', message: 'Password modificata', color: 'green' });
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore nel cambio password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack gap="lg">
      <Group>
        <IconSettings size={28} color="rgb(32, 83, 87)" />
        <Title order={2}>Il Mio Profilo</Title>
      </Group>

      <Grid>
        {/* Info Utente */}
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Card shadow="sm" padding="lg" radius="md" withBorder h="100%">
            <Group mb="md">
              <ThemeIcon color="teal" variant="light" size="lg">
                <IconUser size={20} />
              </ThemeIcon>
              <Text fw={600}>Informazioni Account</Text>
            </Group>
            <Table>
              <Table.Tbody>
                <Table.Tr>
                  <Table.Td fw={600} w="40%">Nome</Table.Td>
                  <Table.Td>{user?.nome}</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td fw={600}>Cognome</Table.Td>
                  <Table.Td>{user?.cognome}</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td fw={600}>Email</Table.Td>
                  <Table.Td>{user?.email}</Table.Td>
                </Table.Tr>
                <Table.Tr>
                  <Table.Td fw={600}>Ruolo</Table.Td>
                  <Table.Td>
                    <Badge color={user?.ruolo === 'admin' ? 'teal' : 'gray'} variant="light">
                      {user?.ruolo?.toUpperCase()}
                    </Badge>
                  </Table.Td>
                </Table.Tr>
              </Table.Tbody>
            </Table>
          </Card>
        </Grid.Col>

        {/* Cambio Password */}
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Card shadow="sm" padding="lg" radius="md" withBorder h="100%">
            <Group mb="md">
              <ThemeIcon color="teal" variant="light" size="lg">
                <IconLock size={20} />
              </ThemeIcon>
              <Text fw={600}>Cambia Password</Text>
            </Group>
            
            {error && (
              <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light" mb="md">
                {error}
              </Alert>
            )}
            
            {success && (
              <Alert icon={<IconCheck size={16} />} color="green" variant="light" mb="md">
                {success}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <Stack gap="md">
                <PasswordInput
                  label="Password Attuale"
                  required
                  value={form.password_attuale}
                  onChange={(e) => setForm({...form, password_attuale: e.target.value})}
                />
                <PasswordInput
                  label="Nuova Password"
                  required
                  description="Minimo 6 caratteri"
                  value={form.password_nuova}
                  onChange={(e) => setForm({...form, password_nuova: e.target.value})}
                />
                <PasswordInput
                  label="Conferma Nuova Password"
                  required
                  value={form.password_conferma}
                  onChange={(e) => setForm({...form, password_conferma: e.target.value})}
                />
                <Button type="submit" loading={loading}>
                  Cambia Password
                </Button>
              </Stack>
            </form>
          </Card>
        </Grid.Col>
      </Grid>
    </Stack>
  );
}

export default Profilo;
